import React, { useContext } from 'react';
import Nav from './Nav';
import { ContextData } from '../../context/Context';

export default function Aside() {
  const { Person } = useContext(ContextData);
  return (
    <aside className="aside dashboard-sidebar hide-at-prnt" aria-label="Dashboard navigation">
      <div className="dashboard-brand">
        <img src="/assets/fit.jpeg" alt="Fityanul Islam emblem" width="46" height="46" />
        <div>Fityanul Islam<span>OF NIGERIA</span></div>
      </div>
      <div className="dashboard-workspace-label">MEMBERSHIP WORKSPACE</div>
      <nav aria-label="Dashboard pages"><Nav /></nav>
      <div className="dashboard-sidebar-profile">
        <span className="dashboard-avatar" aria-hidden="true">{Person?.fname?.charAt(0) || 'F'}</span>
        <div><strong>{Person?.fname || 'Welcome'}</strong><span>{Person?.usertype || 'Membership portal'}</span></div>
      </div>
    </aside>
  );
}
